import React from 'react';
import './BangoBackButton.css';
import { useStore } from 'Hooks/useStore';

const BangoBackButton = () => {
  const { redirectUrl } = useStore('integrations.bango');
  //Currently, only Verizon Bango supports SheerID and uses this button
  const text = 'Back to Verizon +play';
  if (!redirectUrl) return null;
  return (
    <a href={redirectUrl} className="bangoBackButton">
      <img
        className="bangoBackIcon"
        src="/account/static/images/arrow-back-white.svg"
        height="20"
        width="20"
        alt="back-arrow"
      />
      {text}
    </a>
  );
};
export default BangoBackButton;
